/* ============================================================
   Don Don Care — Brand interactions
   Scroll reveals + animated counters
   No dependencies. IntersectionObserver + requestAnimationFrame.
   ============================================================ */
(function () {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     SCROLL REVEAL
     Add [data-reveal] or [data-reveal-stagger] to an element.
     Adds .is-visible when 15% of the element enters viewport.
     ============================================================ */
  function initReveal() {
    const targets = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');
    if (!targets.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -80px 0px',
      }
    );

    targets.forEach((el) => observer.observe(el));
  }

  /* ============================================================
     ANIMATED COUNTER
     <span data-countup="238" data-countup-duration="1600">0</span>
     Counts from 0 to target when scrolled into view.
     Uses ease-out curve for smoother deceleration.
     ============================================================ */
  function initCountUp() {
    const counters = document.querySelectorAll('[data-countup]');
    if (!counters.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      counters.forEach((el) => {
        el.textContent = el.getAttribute('data-countup');
      });
      return;
    }

    const animate = (el) => {
      const target = parseInt(el.getAttribute('data-countup'), 10);
      const duration = parseInt(el.getAttribute('data-countup-duration'), 10) || 1600;
      if (Number.isNaN(target)) return;
      const startTime = performance.now();
      const startValue = 0;

      const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

      const tick = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeOutQuart(progress);
        const current = Math.round(startValue + (target - startValue) * eased);
        el.textContent = current.toLocaleString('nl-NL');
        if (progress < 1) {
          requestAnimationFrame(tick);
        }
      };

      requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.4,
      }
    );

    counters.forEach((el) => {
      el.textContent = '0';
      observer.observe(el);
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initReveal();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run on Shopify section load (theme editor) */
  document.addEventListener('shopify:section:load', init);
})();
